module.exports = __webpack_public_path__ + "9d396807e3f9237eb5a24b5525fa1d18.pdf";